import React from 'react';
import ReactDOM from 'react-dom/client';
// import './index.css';
import './App.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import "@aws-amplify/ui-react/styles.css"; 
import 'swiper/swiper-bundle.css'
// import "swiper/css";
// import 'swiper/swiper-bundle.min.css'
// import "swiper/css/navigation";
// import { Amplify } from 'aws-amplify';
// import awsconfig from './aws-exports'; 
// Amplify.configure(awsconfig);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

  <BrowserRouter>
  <React.StrictMode>
    <App />
  </React.StrictMode>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
